<agpr-dialog-container
    [id]="id"
    [heading]="'Common.lhp.groupSelectionDialog.header'"
    (close)="cancel()"
>
    <div class="agpr-groupSelectionDialog-content">
        <agpr-autocomplete
            [id]="id + '_groupSelection'"
            [dropdown]="true"
            label="Common.lhp.groupSelectionDialog.autocomplete.label"
            placeholder="Common.lhp.groupSelectionDialog.autocomplete.placeholder"
            labelField="name"
            [suggestions]="groupOptions$"
            [(ngModel)]="selectedOption"
            [clearOnBlur]="false"
            [required]="true"
            [customOptions]="autocompleteCustomOptions"
        ></agpr-autocomplete>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancel'"
            (click)="cancel()"
            [label]="'cancel'"
            [style]="buttonStyle.secondary"
        ></agpr-button>
    </ng-template>

    <ng-template #footerRight>
        <agpr-button
            [id]="id + '_ok'"
            (click)="ok()"
            label="Common.lhp.groupSelectionDialog.okButton"
            ariaLabel="Common.lhp.groupSelectionDialog.okButton"
            [disabled]="!selectedOption"
            [style]="buttonStyle.primary"
            [tooltip]="(!selectedOption) ? 'Common.lhp.groupSelectionDialog.okButton.disabled.tooltip' : ''"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
